// extracted by mini-css-extract-plugin
module.exports = {"Quiz":"Quiz_Quiz__2wya1","QuizWrapper":"Quiz_QuizWrapper__191J4"};